<template>
    <div class="">
		<h2 class="main-title mb-3">Form</h2>
        <form @submit.prevent="submitForm">
            <div class="card">
                <div class="card-header card1">
                    <strong v-if="status">New Form</strong>
                    <strong v-else>Update Form</strong>
                    <router-link to="/forms" type="submit" class="btn d-flex align-item-center btn-primary"><i class="ri-list-check me-1"></i> FORMS</router-link>
                </div>
                <div class="card-body mb-3">
                    <div class="row g-3">
                        <div class="col-md-4">
                            <label class="form-label">Field Name</label><span class="text-danger"> *</span>
                            <input type="text" placeholder="Field Name" class="form-control" :class="{ 'is-invalid': errors.field_name }" v-model="form.field_name" ref="field_name" />
                            <span v-if="errors.field_name" class="invalid-feedback">{{ errors.field_name }}</span>
                        </div>
                        <div class="col-md-4">
                            <label class="form-label">Display Name</label><span class="text-danger"> *</span>
                            <input type="text" placeholder="Display Name" class="form-control" :class="{ 'is-invalid': errors.display_name }" v-model="form.display_name"  />
                            <span v-if="errors.display_name" class="invalid-feedback">{{ errors.display_name }}</span>
                        </div>
                        <div class="col-md-4">
                           <label class="form-label">Field Type</label><span class="text-danger"> *</span>
                                    <select class="form-control" :class="{ 'is-invalid': errors.field_type}" v-model="form.field_type">
                                        <option value="">Select Field Type</option>
                                        <option value="text">Text</option>
                                        <option value="number">Number</option>
                                        <option value="textarea">Text Area</option>
                                        <option value="date">Date</option>
                                        <option value="date_time">Date & Time</option>
                                        <option value="select">Dropdown</option>
                                    </select>
                                    <span v-if="errors.field_type" class="invalid-feedback">{{ errors.field_type }}</span>
                        </div>
                        <div class="col-md-4">
                           <label class="form-label">Is Required</label><span class="text-danger"> *</span>
                                    <select class="form-control" :class="{'is-invalid':errors.is_required}" v-model="form.is_required">
                                        <option value="">Select Is Required</option>
                                        <option value="true">Yes</option>
                                        <option value="false">No</option>
                                    </select>
                                    <span v-if="errors.is_required" class="invalid-feedback">{{ errors.is_required }}</span>
                        </div>
                        <div class="col-md-4" v-if="form.field_type=='Select'">
                                    <label class="form-label">Field Values</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Field Values" class="form-control" :class="{ 'is-invalid': errors.field_values}" v-model="form.field_values" />
                                    <span v-if="errors.field_values" class="invalid-feedback">{{ errors.field_values }}</span>
                                </div>

                        <div class="col-md-4">
                            <label class="form-label">Field Length</label><span class="text-danger"> *</span>
                            <input type="number" placeholder="Field Length" class="form-control" :class="{ 'is-invalid': errors.field_length }" v-model="form.field_length" />
                            <span v-if="errors.field_length" class="invalid-feedback">{{ errors.field_length}}</span>
                        </div>
                    </div>
                </div>
                <div class="card-footer text-end">
                    <button type="reset" class="btn btn-danger me-2" @click.prevent="discard()"><i class="ri-close-line icon_hgt"></i> DISCARD</button>
                    <button v-if="status" type="submit" class="btn btn-primary"><i class="ri-save-line icon_hgt"></i> SUBMIT</button>
                    <button v-else type="submit" class="btn btn-primary"><i class="ri-save-line icon_hgt"></i> UPDATE</button>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
    export default {
        name: "Forms.Create",
        components: {},
        data() {
            return {
                form: {
                    dynamic_form_id: "",
                    field_name: "",
                    display_name:"",
                    field_type: "",
                    field_values: "",
                    is_required: "",
                    field_length: "",
                },
                status: true,
                forms: [],
                errors: [],
            };
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                if (to.name == "Forms.Create") {
                    vm.$refs.field_name.focus();
                } else {
                    vm.status = false;
                    let uri = { uri: "dynamicForm/viewDynamicForm", data: { dynamic_form_id: to.params.dynamic_form_id } };
                    vm.$store
                        .dispatch("post", uri)
                        .then(function (response) {
                            vm.form = response.data.data;
                        })
                        .catch(function (error) {
                            vm.errors = error.response.data.errors;
                            vm.$store.dispatch("error", error.response.data.message);
                        });
                }
            });
        },
        methods: {
            submitForm() {
                let vm = this;
                if (vm.status) {
                    vm.create();
                } else {
                    vm.update();
                }
            },
            create() {
                let vm = this;
                let loader = vm.$loading.show();
                let uri = { uri: "dynamicForm/addDynamicForm", data: vm.form };
                vm.$store
                    .dispatch("post", uri)
                    .then(function () {
                        loader.hide();
                        vm.$store.dispatch("success", "Form is successfully created");
                        vm.$router.push("/forms");
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            update() {
                let vm = this;
                let loader = vm.$loading.show();
                let uri = { uri: "dynamicForm/updateDynamicForm", data: vm.form };
                vm.$store
                    .dispatch("post", uri)
                    .then(function () {
                        loader.hide();
                        vm.$store.dispatch("success", "Form is successfully updated");
                        vm.$router.push("/forms");
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            discard() {
                let vm = this;
                vm.form.field_name = "";
                vm.form.display_name = "";
                vm.form.field_type = "";
                vm.form.field_values = "";
                vm.form.is_required = "";
                vm.form.field_length = "";
                vm.$refs.field_name.focus();
                vm.errors = [];
                vm.status = true;
            },
        },
    };
</script>
